import styled from "styled-components";
import breakpoints from "../../../styles/breakpoints";
import Button from "../../atoms/Button";
import ButtonLink from "../../atoms/ButtonLink";

export const ChallengesImage = styled.img`
  ${breakpoints.xsDown} {
    margin-bottom: -20px;
  }
`;

const CommonButtonStyles = `
  max-width: 340px;
  margin-bottom: 12px;
  ${breakpoints.smDown} {
    max-width: 100%;
  }
`;

export const StyledGhostButtonLink = styled(ButtonLink).attrs(() => ({
  full: true,
  lg: true,
  ghost: true,
}))`
  ${CommonButtonStyles}
`;

export const StyledButton = styled(Button).attrs(() => ({
  full: true,
  lg: true,
}))`
  ${CommonButtonStyles}
`;

export const StyledDoneButton = styled(StyledButton)`
  ${breakpoints.xsDown} {
    max-width: 93%;
    align-self: flex-end;
    position: absolute;
    bottom: 54px;
  }
`;
